// extracted by mini-css-extract-plugin
export var active = "_c6-7";
export var blink = "_c6-8";
export var dropDownSelector = "_c6-4";
export var dropDownWrapper = "_c6-3";
export var fakeCursor = "_c6-6";
export var fontSizeButton = "_c6-9";
export var formQuillEditor = "_c6-0";
export var pressed = "_c6-a";
export var qlBlank = "_c6-1";
export var textFormattingToolbar = "_c6-2";
export var textToolbarOption = "_c6-5";